import { logger } from '@/ui'
import type { ReactNode } from 'react'
import { ErrorBoundary } from 'react-error-boundary'

export type NavWidgetBoundaryProps = {
	children: ReactNode
	widget: string
}

export function NavWidgetBoundary({ children, widget }: NavWidgetBoundaryProps) {
	return (
		<ErrorBoundary
			fallback={null}
			onError={(error, info) =>
				logger.error(error, {
					tags: { error_boundary: `nav-widget-${widget}`, component_name: widget },
					data: { errorBoundary: { componentStack: info.componentStack, widget } },
				})}
		>
			{children}
		</ErrorBoundary>
	)
}
